import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { LocalFaturamentoCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-local-faturamento-multiselect',
    templateUrl: './local-faturamento-multiselect.component.html',
    styleUrls: ['./local-faturamento-multiselect.component.less']
})
export class LocalFaturamentoMultiselectComponent implements OnInit {
    /** Locais de faturamentos selecinados */
    @Input() idsLocaisFaturamentos: number[];
    /** Ao alterar a seleção dos locais de faturamentos */
    @Output() idsLocaisFaturamentosChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Local de Faturamento';
    @Input() checked = 'Local de Faturamento';
    @Input() checkedPlural = 'Locais de Faturamentos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum local encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private localFaturamentoCrudHttpService: LocalFaturamentoCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-local-faturamento ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os locais de faturamentos para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        this.localFaturamentoCrudHttpService.search()
            .pipe(
                take(1)
            )
            .subscribe(
                entities => {
                    if (entities) {
                        entities.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome,
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os locais de faturamentos', error)
            );
    }

    /** Ao alterar a seleção dos locais de faturamentos */
    onChange() {
        this.idsLocaisFaturamentosChange.emit(this.idsLocaisFaturamentos);
    }
}
